import { render, staticRenderFns } from "./AppSimplebar.vue?vue&type=template&id=6c2704cb&"
import script from "./AppSimplebar.vue?vue&type=script&lang=js&"
export * from "./AppSimplebar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports